const Const = {
    LEFT_SIDE_BAR_IS_FOLDED_OPEN: 'LEFT_SIDE_BAR_IS_FOLDED_OPEN',
    LEFT_SIDE_BAR_MOBILE_IS_ACTIVE: 'LEFT_SIDE_BAR_MOBILE_IS_ACTIVE',
};

export default Const;